import { StopPayment } from 'model';
import React, { useState } from 'react';
import "../../mobile.css";
import "./styles.css";

/**
 * @function MobileStopPaymentView
 * @param {STRING} accountNickname - Sets the account nickname  
 * @param {STRING} date - Sets the date of the payment
 * @param {STRING} startingCheckNumber - Sets the starting check number
 * @param {STRING} endingCheckNumber - Sets the ending check number
 * @param {STRING} amount - Sets the amount of the payment
 * @return {React.Component}
 * @exported true
 * @description The MobileStopPaymentView shows the stopped payment table in the mobile and tablet view 
 * @example
 * <MobileStopPaymentView accountNickname="Personal Checking" date="03/03/2023" startingCheckNumber="1" endingCheckNumber="2" amount="$X.XX" />
 */

export default function MobileStopPaymentView(props){
  const payment = props.payment ?? StopPayment.firstInstanceOf();

  return(
    <div className="stop-payment-mobile-container show-on-mobile">
      <div className="flex-container flex-vertical">
        <div className="flex-container flex-horizontal flex-height">
          <p className="flex-width">Account:</p>
          <p className="set-width">{ payment.account?.nickname }</p>
        </div>
        <div className="flex-container flex-horizontal flex-height">
          <p className="flex-width">Date:</p>
          <p className="set-width">{ payment.checkDate.format("m/d/Y") + " " + payment.checkTime }</p>
        </div>
        <div className="flex-container flex-horizontal flex-height">
          <p className="flex-width">Starting Check Number:</p>
          <p className="set-width">{ payment.startCheck }</p>
        </div>
        <div className="flex-container flex-horizontal flex-height">
          <p className="flex-width">Ending Check Number:</p>
          <p className="set-width">{ payment.endCheck }</p>
        </div>
        <div className="flex-container flex-horizontal flex-height">
          <p className="flex-width">Amount:</p>
          <p className="set-width">{ payment.amount.format() }</p>
        </div>
      </div>
    </div>
  );
}